import React from 'react';
import { Box, Typography, Button, IconButton, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from 'react-router-dom';
import { colors } from '../constants';

/**
 * Standard section header: optional back button, title/subtitle, and action
 * area on the right (buttons or arbitrary nodes).
 */
export default function PageHeader({
  title,
  subtitle,
  onBack,
  backTo,
  actionLabel,
  actionIcon,
  onAction,
  actions,
}) {
  const history = useHistory();
  const handleBack = () => {
    if (onBack) return onBack();
    if (backTo) return history.push(backTo);
    return history.goBack();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        mb: 3,
        flexWrap: 'wrap',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5}>
        {(onBack || backTo) && (
          <IconButton onClick={handleBack} size="small" aria-label="back">
            <ArrowBackIcon />
          </IconButton>
        )}
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700, color: colors.navy }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" sx={{ color: colors.gray500, mt: 0.5 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Stack>

      <Stack direction="row" spacing={1.5} alignItems="center">
        {actions}
        {actionLabel && (
          <Button
            variant="contained"
            startIcon={actionIcon}
            onClick={onAction}
            sx={{
              backgroundColor: colors.primary,
              textTransform: 'none',
              fontWeight: 600,
              '&:hover': { backgroundColor: colors.primaryDark },
            }}
          >
            {actionLabel}
          </Button>
        )}
      </Stack>
    </Box>
  );
}
